import React, { Component } from 'react';
import { ComponentType } from 'react';
import { PhoneIcon, RadioIcon, RefreshCwIcon, SunIcon, ThermometerIcon, WavesIcon, WrenchIcon, ZapIcon, ActivityIcon, BoxesIcon } from 'lucide-react';
import { categories, CONTACT } from '../../data/modalities';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, ComponentType<{
  className?: string;
}>> = {
  'class-iv-laser': ZapIcon,
  shockwave: ActivityIcon,
  heit: RadioIcon,
  led: SunIcon,
  thermal: ThermometerIcon,
  'deep-oscillation': WavesIcon,
  'used-equipment': RefreshCwIcon,
  concierge: BoxesIcon,
  'neuro-reformer': WrenchIcon,
  regenmedix: WrenchIcon
};
const categoryAnchorIds: Record<string, string> = {
  'class-iv-laser': 'category-class-iv-laser',
  shockwave: 'category-shockwave',
  heit: 'category-high-energy-inductive-therapy',
  led: 'category-whole-body-red-light-led-therapy',
  thermal: 'category-thermal-imaging',
  'deep-oscillation': 'category-deep-oscillation',
  'used-equipment': 'category-used-equipment',
  concierge: 'category-concierge-modality-suite',
  'neuro-reformer': 'category-neuro-reformer',
  regenmedix: 'category-regenmedix'
};
function EquipmentPanel({
  id,
  Icon
}: {
  id: string;
  Icon: ComponentType<{
    className?: string;
  }>;
}) {
  const label = id === 'used-equipment' ? 'PRE-OWNED' : id === 'concierge' ? 'CURATED SYSTEM' : id === 'neuro-reformer' || id === 'regenmedix' ? 'UPCOMING' : 'TECHNOLOGY';
  return <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden border-b border-slate-100 bg-slate-50" data-id="element-132" data-mp="2q3vn6qefac7n">
      <div className="absolute inset-x-8 top-1/2 h-px bg-teal/25" data-id="element-133" data-mp="2h2e9tfsegomn" />
      <div className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full border border-navy/10" data-id="element-134" data-mp="2h24hvmnso7eb" />
      <div className="absolute left-1/2 top-1/2 h-20 w-20 -translate-x-1/2 -translate-y-1/2 rounded-full border border-teal/40" data-id="element-135" data-mp="15n8zbpm11lsh" />
      <div className="absolute flex h-20 w-28 items-center justify-center rounded-2xl border border-navy/15 bg-white shadow-[0_12px_28px_-18px_rgba(26,27,75,0.45)]" data-id="element-136" data-mp="175fxlwcybb3y">
        <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-navy text-teal-light" data-id="element-137" data-mp="y3q3ujvlk030">
          <Icon className="h-7 w-7" data-id="element-138" data-mp="1251p6d7ftz5e" />
        </div>
      </div>
      <span className="absolute bottom-5 rounded-full border border-navy/10 bg-white/80 px-2.5 py-1 text-[10px] font-semibold tracking-[0.16em] text-navy/55" data-id="element-139" data-mp="123i9anpp1q45">
        {label}
      </span>
      <span className="absolute left-8 top-7 h-2 w-2 rounded-full bg-teal" data-id="element-140" data-mp="t67uisdo3iuh" />
      <span className="absolute right-9 top-10 h-1.5 w-1.5 rounded-full bg-navy/30" data-id="element-141" data-mp="egs5bgtsblgw" />
    </div>;
}
export function Categories() {
  return <section id="products" className="w-full bg-white py-20 sm:py-24" data-id="element-142" data-mp="jcqydhq25rnn">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-143" data-mp="5fklu4vxgp6v">
        <SectionHeading eyebrow="Product Categories" title="Technologies to understand before you invest" description="Start with the category, then call JAG to compare product families, practical fit, training needs, and implementation considerations." data-id="element-144" data-mp="advs65n0khkc" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-145" data-mp="3vy684vr2v7ip">
          {categories.map(category => {
          const Icon = icons[category.id] ?? ZapIcon;
          const categoryAnchorId = categoryAnchorIds[category.id];
          return <article id={categoryAnchorId} key={category.id} className="group flex h-full scroll-mt-[104px] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_2px_20px_-8px_rgba(26,27,75,0.14)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-teal/40 hover:shadow-[0_18px_40px_-16px_rgba(26,27,75,0.25)]" data-id="element-146" data-mp="9pd8m4xr9jpc">
                {category.image ? <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden border-b border-slate-100 bg-slate-50 p-6" data-id="element-147" data-mp="nk7c5u43vm57">
                    <img src={category.image} alt={category.name} className="h-full w-full object-contain" data-id="element-148" data-mp="2mxo3ogc65n3e" />
                  </div> : <EquipmentPanel id={category.id} Icon={Icon} data-id="element-149" data-mp="2voy50ttfmnin" />}
                <div className="flex flex-1 flex-col p-6" data-id="element-150" data-mp="1z0qnab7l8t9v">
                  <div className="flex items-start justify-between gap-3" data-id="element-151" data-mp="1z2bhu0twkc7q">
                    <div className="flex items-center gap-2.5" data-id="element-152" data-mp="23zbr0km1tv32">
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-153" data-mp="27zlvtty3ufgc">
                        <Icon className="h-[18px] w-[18px]" data-id="element-154" data-mp="2d0jgcd6l7ll0" />
                      </span>
                      <h3 className="font-display text-[17px] font-bold leading-tight text-navy" data-id="element-155" data-mp="3jesi9chnye3f">
                        {category.name}
                      </h3>
                    </div>
                    {category.status && <span className="rounded-full bg-teal/10 px-2 py-1 text-[9px] font-semibold uppercase tracking-wide text-teal" data-id="element-156" data-mp="2fk4889437xl">
                        Coming soon
                      </span>}
                  </div>
                  <p className="mt-3 text-[13.5px] leading-relaxed text-charcoal/75" data-id="element-157" data-mp="3krypd7bjvshy">
                    {category.detail}
                  </p>
                  <p className="mt-4 text-[11px] font-medium leading-relaxed text-slate-500" data-id="element-158" data-mp="3ftnklb04486l">
                    {category.products.join(' · ')}
                  </p>
                  <a href={CONTACT.phoneHref} className="mt-5 inline-flex items-center gap-2 text-[13px] font-semibold text-navy transition-colors hover:text-teal focus-visible:outline-none focus-visible:text-teal" data-id="element-159" data-mp="35v7osuq54aqr">
                    <PhoneIcon className="h-4 w-4" data-id="element-160" data-mp="100ok9gvkf9x7" />
                    Call About This Category
                  </a>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}